/* stylelint-disable max-nesting-depth, selector-max-compound-selectors */
.my-orders-overview {
    &__cta-buttons-container {
        display: flex;
        align-items: flex-start;
        flex-direction: column;
        margin-bottom: 10px;

        @media only screen and (min-width: 768px) {
            flex-direction: row;
            flex-wrap: wrap;
        }
    }

    .my-orders-overview__button-direct-search {
        margin-left: auto;
        display: none;

        @media only screen and (min-width: $tablet) {
            display: block;
        }
    }

    &__failure {
        text-align: center;
        margin-top: 70px;
        max-width: 80%;
        margin: 80px auto 0;
        display: none;

        ux-icon {
            color: red;
            margin: 0 auto;
            font-size: 50px;
            text-align: center;
        }
    }

    &__cta-buttons-container > * {
        min-width: 100%;
        margin-bottom: 15px;

        @media only screen and (min-width: 768px) {
            min-width: auto;
            margin-right: 20px;
        }
    }

    &__result-set {
        position: relative;

        @include legacy-gridle-state(large) {
            text-align: center;
        }

        @include legacy-gridle-state(mtd) {
            text-align: left;
        }
    }

    &__table-container.my-orders-overview__table-container {
        @media (max-width: 567px) {
            padding-top: 10px !important;
        }
    }

    .my-orders-overview__direct-search-element {
        order: -1;
        margin-bottom: 20px;

        @media only screen and (min-width: 768px) {
            min-width: 100%;
        }

        @media only screen and (min-width: $tablet) {
            display: none;
            order: 1;
        }
    }

    .ux-text-status ux-icon {
        font-size: 18px;
        transform: translateY(2px);

        + ux-icon {
            display: none;
        }
    }

    .ux-table {
        table {
            width: 100%;
        }

        th {
            max-width: none !important;
        }

        tr > td:first-child {
            @include font(light);
        }
    }

    &__filter-container {
        .row + .row {
            margin-top: 30px;
        }
    }

    &__filter-dropdown {
        min-width: 250px;
        position: relative;
        margin-bottom: 10px;

        @media only screen and (min-width: 768px) {
            max-width: 300px;
            display: inline-block;
            margin-right: 18px;
        }
    }

    .filter-flex {
        @media (min-width: 1025px) {
            display: flex;

            > div + div {
                margin-left: 20px;
            }
        }

        > div {
            width: 100%;
            margin-bottom: 10px;

            @media (min-width: 1025px) {
                width: 20%;
            }
        }

        .ux-dropdown__label {
            ux-icon {
                margin-left: 20px;
                transform: translateY(-1px);
            }
        }
    }
}

/* stylelint-enable max-nesting-depth, selector-max-compound-selectors */
